const SMSProviderTypes = [
  {
    value: 'mkom',
    text: 'MKOM',
  },
]
export default SMSProviderTypes
